import LabOrdersV2 from "./v2/LabOrders";

export default function LabOrders(props) {
  return <LabOrdersV2 {...props} />;
}
